"use client";

import { useTranslations } from "next-intl";
import { TriangleAlert } from "lucide-react";
import { useExperimentVariant } from "@/hooks/useExperimentVariant";

// Full-width urgency strip, shown only for the "banner" variant of the
// `hero-delay-banner` experiment (HeroRating hides the rating row in that same
// variant). Rendered as the first child of the hero <section>, so it sits inside
// the section's existing header-clearance padding — below the fixed page header,
// not underneath it. That padding must stay on the <section>: moving it to an
// inner wrapper puts this banner at y=0 behind the fixed header.
// Colours assume the dark hero — the surface and text were light-on-white until
// the hero went full-bleed ink, which left this dark on dark.
// Renders null by default (control, SSR, no consent, flags
// still loading), so the indexed default page is unaffected and it only appears
// post-hydration for the assigned group. Reuses the `urgency` token + "Let op"
// language from the UrgencyBanner section lower on the page.
export function HeroDelayBanner() {
  const t = useTranslations("Hero");
  const variant = useExperimentVariant("hero-delay-banner");

  if (variant !== "banner") return null;

  return (
    <div
      data-track-section="hero_delay_banner"
      className="border-y border-urgency/25 bg-urgency/15 lg:mb-8"
    >
      <div className="mx-auto flex w-full max-w-[76rem] items-center justify-center gap-2.5 px-4 py-2.5 text-center sm:gap-3 sm:px-8 lg:px-8">
        <TriangleAlert className="size-4 shrink-0 text-urgency sm:size-5" />
        <p className="text-[13px] font-semibold leading-snug text-white sm:text-sm">
          <span className="font-bold uppercase tracking-wider text-urgency">
            {t("delayBannerEyebrow")}
          </span>{" "}
          {t("delayBannerText")}
        </p>
      </div>
    </div>
  );
}
